var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.url,"alt":_vm.alt,"height":_vm.height,"width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }